import { format, parse } from 'url';

import { DEFAULT_LANGUAGE } from '../../store/internationalization/constants';

const appendLangPrefix = (link: string, language: string) => {
  if (language === DEFAULT_LANGUAGE) {
    return link;
  }

  const urlObj = parse(link);

  if (urlObj.pathname) {
    const prevPathname = urlObj.pathname;
    urlObj.pathname = `/${language}`;

    // Preventing trailing slash for index route
    if (prevPathname !== '/') {
      urlObj.pathname += prevPathname;
    }
  }

  return format(urlObj);
};

export default appendLangPrefix;
